import { Component, ViewChild } from '@angular/core';
import { TeamService } from 'src/app/shared/services/team.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogDirective } from 'src/shared-app-portal/components/dialog/dialog.directive';
import { Workspace } from 'src/app/shared/models/workspace/workspace';
import { TeamFilterService } from 'src/app/teams/teams-home/team-filter.service';
import { Router } from '@angular/router';

@Component({
  selector: 'team-workspace-migration',
  templateUrl: './team-workspace-migration.component.html',
  styleUrls: ['./team-workspace-migration.component.scss'],
  standalone: false
})
export class TeamWorkspaceMigrationComponent {
  public saving: boolean;
  public workspaces: Workspace[] = [];
  private teamId: string;

  constructor(
    private formBuilder: FormBuilder,
    private teamService: TeamService,
    private teamFilterService: TeamFilterService,
    private router: Router
  ) {}

  @ViewChild(DialogDirective, { static: true })
  dialog: DialogDirective;
  formGroup: FormGroup<{
    workspace: FormControl<string>;
  }>;

  public openModal = async (teamId: string, teamName: string, workspaces: Workspace[]) => {
    this.teamId = teamId;
    this.workspaces = workspaces;

    this.formGroup = this.formBuilder.group({
      workspace: ['', [Validators.required]]
    });

    await this.dialog
      .open({
        header: `Migrate ${teamName} to Workspace`,
        form: this.formGroup,
        onOkay: () => {
          return this.migrateTeamToWorkspace();
        }
      })
      .then((result) => {
        this.saving = false;
        if (!result) return;
        this.teamFilterService.applyExistingFilters();
        this.router.navigate(['/teams'], { replaceUrl: true });
      });
  };

  public migrateTeamToWorkspace(): Promise<boolean> {
    if (!this.saving && this.formGroup.controls.workspace.value) {
      this.saving = true;
      return new Promise<boolean>((resolve) => {
        this.teamService
          .migrateToWorkspace(this.teamId, this.formGroup.controls.workspace.value)
          .subscribe({
            next: (team) => {
              this.saving = false;
              resolve(!!team);
            },
            error: () => {
              this.saving = false;
              resolve(false);
            }
          });
      });
    }
    return Promise.resolve(false);
  }
}
